import { render, staticRenderFns } from "./MarkerWrapper.vue?vue&type=template&id=8d561c04"
import script from "./MarkerWrapper.vue?vue&type=script&lang=js"
export * from "./MarkerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports